module.exports = "/images/car-progress.svg?16e0b6146a7a7bce8052112765d660a0";